import { API } from '../Api';
import { LiveDonate } from '../../utils/live-donate';

// Công khai — trang chủ đọc không cần đăng nhập.
export const getLiveDonates = (take = 20) =>
  API.get<LiveDonate[]>('/v1/payment-service/public/live-donates', { params: { take } }).then((r) => r.data);
